import { render } from "./role.html?vue&type=template&id=15b45fd8&scoped=true&ts=true"
import script from "./role.ts?vue&type=script&lang=ts"
export * from "./role.ts?vue&type=script&lang=ts"

import "./role.scss?vue&type=style&index=0&id=15b45fd8&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b45fd8"]])

export default __exports__